import React from "react";

import { TextField } from "@mui/material";

import type { TextFieldProps } from "@mui/material";

/**
 * A custom TextField component that allows for number input without the default spinners.
 * @param props - The props for the TextField component.
 * @returns The NumberField component.
 */
export const NumberField: React.FC<TextFieldProps> = (props: TextFieldProps) => {
  return (
    <TextField
      {...props}
      type="number"
      inputProps={{
        step: "any",
        ...props.inputProps,
      }}
      onWheel={(e) => {
        if (e.target instanceof HTMLElement) e.target.blur();
      }}
      onKeyDown={(e) => {
        // Block scientific notation and arrow keys
        if (["e", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
          e.preventDefault()
        }

        props.onKeyDown?.(e)
      }}
      sx={{
        "& input::-webkit-outer-spin-button": { WebkitAppearance: "none", margin: 0 },
        "& input::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
        "& input": { MozAppearance: "textfield" },
        ...props.sx,
      }}
    />
  );
}
